import { CornerUpRight } from 'lucide-react';

const content = {
  heroSection: {
    title: '<span class="gradient-text">Exclusive Intelligence</span> on European Gas, Chinese Gas & LNG Markets',
    subtitle: 'Introductory offer',
  },

  clientsSection: {
    title: 'Trusted by over <span class="gradient-text">150</span> Organisations Worldwide',
    description: 'Trusted by leading energy trading firms for actionable insights',
  },

  ctaBanner: {
    label: 'Offer',
    title: 'Try Our Introductory Offer.<br/>Free Sample Report, No Strings Attached.',
    cta: {
      text: 'Contact us',
      icon: CornerUpRight,
      link: '/contact',
    },
  },

  whoWeServeSection: {
    title: 'Who We Serve',
    description:
      'From strategy to execution, eklipX Research supports teams across the organization in optimizing performance and achieving excellence.',
    cards: [
      {
        title: 'Traders & Analysts',
        description:
          'Identify market opportunities with real-time fundamentals, volatility insights, and trade ideas. Execute trades with greater confidence across global gas and LNG markets.',
      },
      {
        title: 'Portfolio Managers',
        description:
          'Identify market opportunities with real-time fundamentals, volatility insights, and trade ideas. Execute trades with greater confidence across global gas and LNG markets.',
      },
      {
        title: 'Risk Managers',
        description:
          'Monitor market stress signals, supply disruptions, and policy shifts. Strengthen risk oversight with integrated data and scenario-driven analysis.',
      },
    ],
  },

  pricingSection: {
    plans: [
      {
        mostPopular: true,
        name: 'European Gas Market Intelligence',
        description:
          'For those exposed to European gas & LNG market dynamics and their impact on trade flows, pricing and volatility.',
        listItems: [
          'Gas market fundamentals - supply, demand, storage, and trade flows.',
          'Country-level flow balances & net supply shifts.',
          'Daily nominations data - tracking gas imports & exports across Europe',
          'Volatility spread analysis and financial trading indicators.',
          'Macroeconomic & policy insights - government policies and sector-specific analysis.',
        ],
        price: {
          gbp: 299,
          usd: 399,
          eur: 359,
        },
        frequency: 'Daily, weekly and bi-weekly reports',
        access: 'Data & dashboard, opinion & trade ideas',
        cta: {
          variant: 'gradient',
          text: 'Contact sales',
          link: '/contact',
        },
      },
      {
        name: 'Chinese + LNG + European Gas Intelligence',
        description:
          "For those exposed to China's gas & LNG market dynamics and their impact on trade flows, pricing and volatility.",
        listItems: [
          '<strong>Everything in the European Gas Market Intelligence package, plus...</strong>',
          'Chinese gas market fundamentals - supply, demand, storage, and trade flows.',
          "China's LNG pricing & heating demand - key drivers of price shifts and demand spikes.",
          'Chinese macroeconomics & policy insights - government policies, import/export trends, and sector-specific analysis.',
          'Asia & US - weekly JKM and LNG monitor and fundamental analysis.',
        ],
        price: {
          gbp: 399,
          usd: 529,
          eur: 479,
        },
        frequency: 'Daily, weekly and bi-weekly reports',
        access: 'Data & dashboard, opinion & trade ideas',
        cta: {
          variant: 'hollow',
          text: 'Contact sales',
          link: '/contact',
        },
      },
    ],
  },
};

export default content;
